module.exports = __webpack_public_path__ + "assets/fonts/2c44f3c0-b468-4077-ad65-6608c51abc46.3c789ef0.ttf";